import { KeyboardEvent } from "react";
import { Container, Props } from "./Checkbox.Parts";
import { CheckedIcon } from "./icons/checked-icon/CheckedIcon";
import { ExcludedIcon } from "./icons/excluded-icon/ExcludedIcon";
import { IndeterminateIcon } from "./icons/indeterminate-icon/IndeterminateIcon";

export const Checkbox = ({
  variant = "unchecked",
  type = "primary",
  disabled,
  ref,
  onKeyDown,
  ...rest
}: Props) => {
  const IconComponent = {
    checked: CheckedIcon,
    excluded: ExcludedIcon,
    indeterminate: IndeterminateIcon,
    unchecked: null,
  }[variant];

  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    onKeyDown?.(e);
    if (e.defaultPrevented || disabled) return;
    if (e.key === " " || e.key === "Enter") {
      e.preventDefault();
      e.currentTarget.click();
    }
  };

  return (
    <Container
      ref={ref}
      $type={type}
      $disabled={disabled}
      tabIndex={0}
      onKeyDown={handleKeyDown}
      {...rest}
    >
      {IconComponent && <IconComponent type={type} />}
    </Container>
  );
};
